import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

// Fire-and-forget: initializes once the DSN comes back from the edge function.
// Errors thrown before init completes are still captured by Sentry's global
// handlers once it boots (within ~one network round-trip).
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
